import DOMPurify from "dompurify";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { glassboxErrorEvent } from "../Glassbox/Glassbox";
import "./Footer.css";

const Footer = () => {
  const [footer, setFooter] = useState([]);
  const { country, language } = useSelector((state) => state.langSettings);

    useEffect(() => {
        const getFooterUrl = (country, language) => {
            if (country === "us" && language === "en") {
                return process.env.REACT_APP_PMC_FOOTER_URL + "us/en/dhs/19?onlyfooter=true&birdseed=false&readonlycountryselector=true";
            }
            return process.env.REACT_APP_PMC_FOOTER_URL +
                encodeURIComponent(country) +
                "/" +
                encodeURIComponent(language) + "/dhs/" + encodeURIComponent(country) + "dhs1" + "?onlyfooter=true&birdseed=false&readonlycountryselector=true";
        };
        const fetchFooter = async (url) => {            
            const res = await fetch(url);            
            if (res.status === 200) {
                const data = await res.text();                
                if (data) {
                    setFooter(data);
                    return;
                }
            }             
            const USfooterRes = await fetch(getFooterUrl("us", "en"));            
            if (USfooterRes.status === 200) {
                const USfooterData = await USfooterRes.text();                
                if (USfooterData) {
                    setFooter(USfooterData);
                }
            }
        };
        const getFooter = async () => {
            try {
                const footerUrl = getFooterUrl(country, language);
                await fetchFooter(footerUrl);
          
      } catch (err) {
        console.log("Footer Error: " + err);
        glassboxErrorEvent(err);
      }
        };


    getFooter();

    //Cookie
    const script = document.createElement("script");
    if (window.location.hostname === "www.dell.com") {
      script.src = `${process.env.REACT_APP_PMC_NEXUS_URL}`;
    } else {
      script.src = `${process.env.REACT_APP_PMC_NEXUS_URL_DEV}`;
    }
    script.crossOrigin = "anonymous";
    script.async = true;
    document.body.appendChild(script);

    const resolvedLanguage = !language || language === "" ? "en" : language;
    const resolvedCountry = !country || country === "" ? "us" : country;

    const dellGlobal = window.Dell || {};
    dellGlobal.Metrics = dellGlobal.Metrics || {};
    dellGlobal.Metrics.sc = dellGlobal.Metrics.sc || {};
    const sc = dellGlobal.Metrics.sc;

    sc.country = sc.country || resolvedCountry;
    sc.language = sc.language || resolvedLanguage;
    sc.segment = sc.segment || "corp";
    sc.customerset = sc.customerset || "19";
    sc.cms = sc.cms || "pmc";
    sc.module = sc.module || "pmc_listremoval";
    sc.pagename = sc.pagename || `${resolvedCountry}:${resolvedLanguage}:${sc.segment}:pmc:pmcListRemoval`;
    sc.applicationname = sc.applicationname || "Transactional:PMC_List_Removal";

    window.Dell = dellGlobal;
  }, [country, language]);
 
  return (
    <div className="footer">
      <div
        className="dds__pt-5"
              dangerouslySetInnerHTML={{ __html: footer }}
      ></div>
    </div>
  );
};

export default Footer;
